import { render, staticRenderFns } from "./GlobalDialogCard.vue?vue&type=template&id=16a7ef24&scoped=true"
import script from "./GlobalDialogCard.vue?vue&type=script&lang=js"
export * from "./GlobalDialogCard.vue?vue&type=script&lang=js"
import style0 from "./GlobalDialogCard.vue?vue&type=style&index=0&id=16a7ef24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a7ef24",
  null
  
)

export default component.exports